// extracted by mini-css-extract-plugin
export var centerText = "_65-8";
export var container = "_65-0";
export var doughnutContainer = "_65-7";
export var legend = "_65-a";
export var legendItemColorDisplay = "_65-b";
export var legendItemLabel = "_65-d";
export var legendItemValue = "_65-c";
export var lg = "_65-5";
export var maxWidth = "_65-9";
export var md = "_65-4";
export var responsive = "_65-6";
export var sm = "_65-3";
export var xs = "_65-2";
export var xxs = "_65-1";